<template>
    <div class="four_bg_box">
        <img class="four_bg_box_img" src="../assets/bg.webp" width="300px" alt="">
        <div class="four_bg_box_con">
            <div class="four_bg_top" style="">
                <!-- 名称 -->
                <img src="../assets/icon_fanhui_create.svg" width="30px" style="margin-left: 11px;" alt="">
                <div
                    style="position: absolute;left: 50%;  transform: translate(-50%, 0%);font-weight: 500;font-size: 20px;">
                    灵犀多语种同传</div>
            </div>
            <!-- 上部分 -->
            <div class="four_bg_input">
                <div style="text-align: start;font-size: 10px;;margin-top: 24px;margin-left: 9px;font-weight: 200;">
                    {{ t("four.titletwo") }}
                </div>
                <div class="four_bg_input_box">
                    <div style="text-align: start;font-size: 12px;font-weight: 400;">{{ t("four.name") }}</div>
                    <div class="four_bg_input_box_tow"></div>
                    <div style="display: flex;    align-items: center;">
                        <span style="font-size: 12px;margin-right: 18px;font-weight: 400;">{{ t("four.sex") }}</span>
                        <div style="display: flex;align-items: center;">
                            <img src="../assets/icon_weixuanzhong.png" width="14px" alt="">
                            <span style="font-size: 12px;margin-left: 4px;">{{ t("four.man") }}</span>
                        </div>
                        <div style="display: flex;align-items: center;margin-left: 12px;">
                            <img src="../assets/icon_xuanzhong.png" width="14px" alt="">
                            <span style="font-size: 12px;margin-left: 4px;">{{ t("four.girl") }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <slot>
            </slot>
        </div>
    </div>

</template>

<script setup>
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>

<style scoped>
.four_bg_box {
    position: relative;
    width: 300px;
    height: 666px;
    /* opacity: 0.8; */
    z-index: 100;

}

.four_bg_box_img {
    position: absolute;
    top: 0;
    left: 0;
}

.four_bg_box_con {
    position: absolute;
    top: 0;
    left: 0;
    width: 300px;
}

.four_bg_top {
    display: flex;
    align-items: center;
    margin-top: 69px;
}

.four_bg_input_box {
    /* width: 100%; */
    /* height: 300px; */
    margin: 12px 12px 12px 12px;
    border-radius: 12px;
    background-color: rgba(255, 255, 255, 0.041);
    margin-top: 14px;
    padding: 12px;
}

.four_bg_input_box_tow {
    margin: 12px 0;
    height: 38px;
    border-radius: 12px;
    background-color: rgba(255, 255, 255, 0.08);
}
</style>